import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { FacilityService } from "../../../shared/services/facility.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { DistrictSchoolService } from "../report-services/district-school.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	selector: "app-district-caassusage",
	templateUrl: "./district-caassusage.component.html",
	styleUrls: ["./district-caassusage.component.css"],
})
export class DistrictCAASSUsageComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private districtschoolService: DistrictSchoolService,
		private facilityService: FacilityService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		StartDate: new Date(),
		EndDate: new Date(),
		FacilityID: 0,
		DistrictSchoolID: 0,
	};

	//Insert Custom Lists Here
	FacilityList: any = [];
	DistrictSchoolList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 387;
	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.loadFacilityList();
		// this.loadDistrictSchoolList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.report.DistrictSchoolID = school.SchoolID;
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadFacilityList() {
		this.report.FacilityID = 0;
		var result = this.facilityService.loadFacilityList("");
		result.subscribe(
			(response) => {
				this.FacilityList = response;

				if (this.FacilityList.length > 1) {
					this.FacilityList.unshift({
						FacilityID: 0,
						FacilityName: "All Facilities",
					});
				} else {
					this.report.FacilityID = this.FacilityList[0].FacilityID;
				}
			},
			(error) => {}
		);
	}

	private loadDistrictSchoolList() {
		this.report.DistrictSchoolID = 0;
		var result = this.districtschoolService.loadDistrictSchoolList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DistrictSchoolList = response;

				if (this.DistrictSchoolList.length > 1) {
					this.DistrictSchoolList.unshift({
						DistrictSchoolID: 0,
						DistrictSchoolDesc: "All DistrictSchools",
					});
				} else {
					this.report.DistrictSchoolID = this.DistrictSchoolList[0].DistrictSchoolID;
				}
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.StartDate) {
			this.errorMessage = "Select the Start Date";
			return;
		}

		if (!this.report.EndDate) {
			this.errorMessage = "Select the End Date";
			return;
		}

		// if (!this.report.FacilityID) {
		//   this.errorMessage = "Select the Facility"
		//   return;
		// }

		// if (!this.report.DistrictSchoolID) {
		//   this.errorMessage = "Select the DistrictSchool"
		//   return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 387;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: StartDate
		strParam += moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 2: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 3: FacilityID
		strParam += "," + this.report.FacilityID + "|FacilityID";

		//Parameter 4: DistrictSchoolID
		strParam += "," + this.report.DistrictSchoolID + "|DistrictSchoolID";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
